var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta"},[_c('a',{staticClass:"cta button is-fullwidth",attrs:{"href":_vm.ville.info.ctaUrl,"target":"_blank"}},[_vm._v("\n\t\t"+_vm._s(_vm.ville.info.ctaLabel)+" "),_c('fleche-icon',{staticClass:"icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }